var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-tax-detail"},[_c('div',{staticClass:"page-tax-detail__content"},[_c('div',{staticClass:"page-tax-detail__title"},[_vm._v("Tax Information")]),_vm._v(" "),_c('div',{staticClass:"page-tax-detail__content-wrap"},[_c('tax-info-notification')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cde31bac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-tax-detail/page-tax-detail.vue
// module id = Wngs
// module chunks = 0